import * as yup from "yup";

export const declinedSchema = yup.object().shape({
   
     declinedDescription: yup.string().required("Declined reason is required").matches(/^[^\s]+(\s+[^\s]+)*/, "Characters must be alphanumaric")
     .min(10, "Min  length 10 characters"),

});